var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"is-bottom-button-bar bottom-button-bar-height position-fixed fixed-bottom p-0 my-0 rounded-0",attrs:{"show":"","variant":"light"}},[_c('b-container',[_c('b-row',{staticClass:"mt-3 mb-2"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }